// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TableCell.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { isFunction, assign, get } from 'lodash/fp';
import UIConstants from 'logic/data/Izenda.UIConstants';
const MIN_HEIGHT_CELL = 29;

@observer
class TableCell extends Component {
  static propTypes = {
    fnGetCellProps: PropTypes.func,
    fnGetCellStyle: PropTypes.func,
    fnGetCellContentStyle: PropTypes.func,
    rowData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    rowIndex: PropTypes.number,
    columnIndex: PropTypes.number,
    column: PropTypes.object,
    registerCell: PropTypes.func,
    unregisterCell: PropTypes.func
  };

  componentDidUpdate() {
    const props = this.props;
    props.didUpdate && props.didUpdate();
    props.cellAfterRenderCallBack && props.cellAfterRenderCallBack();
  }

  setDom = dom => {
    this.dom = dom;
  };

  componentDidMount() {
    const props = this.props;
    const { columnIndex, deep } = props;

    props.didUpdate && props.didUpdate();
    props.cellAfterRenderCallBack && props.cellAfterRenderCallBack();
    props.registerCell && props.registerCell(this.dom, columnIndex, deep);
  }

  componentWillUnmount() {
    const props = this.props;
    const { columnIndex, deep } = props;

    props.unregisterCell && props.unregisterCell(this.dom, columnIndex, deep);
  }

  getContentStyle = (
    fnGetCellContentStyle: any,
    rowData: any,
    columnKey: any,
    rowIndex: number,
    column: any,
    columnIndex: number,
    cellData: any
  ) => {
    const props = this.props;
    const customCellStyle =
      (fnGetCellContentStyle && fnGetCellContentStyle(rowData, columnKey, rowIndex, column, columnIndex, cellData)) ||
      {};

    return assign({ textAlign: props.align }, customCellStyle);
  };

  getCellStyle = (fnGetCellStyle: any, rowData: any, rowIndex: number, columnIndex: number, cellData: any) => {
    let cellWidth;
    const props = this.props;
    const style = (fnGetCellStyle && fnGetCellStyle(rowData, rowIndex, columnIndex, cellData)) || {};
    if (props.newWidth || props.width) {
      cellWidth = props.width + (props.widthUnit === UIConstants.columnWidthSetting.characters ? 'ch' : 'px');

      style.width = props.newWidth ? `${props.newWidth}px` : cellWidth;
      style.maxWidth = props.newWidth ? `${props.newWidth}px` : cellWidth;
      style.minWidth = cellWidth;
      style.minHeight = MIN_HEIGHT_CELL;
    }

    return style;
  };

  getCellContent = (cell: any, rowData: any, column: any, rowIndex: number, columnIndex: number, cellData: any) => {
    if (isFunction(cell)) {
      return cell(rowData, get('key', column), rowIndex, column, columnIndex, this.props.didUpdate, cellData);
    } else {
      return cell;
    }
  };

  render() {
    const props = this.props || {};
    const cellProps = props.fnGetCellProps && props.fnGetCellProps(props.rowData);

    const contentStyle = this.getContentStyle(
      props.fnGetCellContentStyle,
      props.rowData,
      props.columnKey,
      props.rowIndex,
      props.column,
      props.columnIndex,
      props.cellData
    );
    const cellStyle = this.getCellStyle(
      props.fnGetCellStyle,
      props.rowData,
      props.rowIndex,
      props.columnIndex,
      props.cellData
    );

    const cellClass = classnames('table-cell', props.className);

    return (
      <div ref={this.setDom} {...cellProps} className={cellClass} style={cellStyle}>
        <div className="table-cell-content" style={contentStyle}>
          {props.children ||
            this.getCellContent(
              props.cell,
              props.rowData,
              props.column,
              props.rowIndex,
              props.columnIndex,
              props.cellData
            )}
        </div>
      </div>
    );
  }
}

export default TableCell;



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.TableCell.jsx